import { fetchIndeedGraphQL } from 'shared/legacy/hooks/useBrowserExtension/indeed/utils';
import { findContactSummaryByCandidateIdGQLQuery } from './indeed.GQLOperations';
import { getContactSummaryInfosProps } from './indeed.types';

export const getContactSummaryInfos = async ({ indeedConfig, candidateId }: getContactSummaryInfosProps) => {
  const contactSummaryResponse = await fetchIndeedGraphQL(
    findContactSummaryByCandidateIdGQLQuery(candidateId),
    indeedConfig,
  );
  const contactHistoryList = contactSummaryResponse.data?.contactRecord?.contactHistory;
  const candidateInformation = contactSummaryResponse.data?.contactRecord?.candidate;

  return { contactHistoryList, candidateInformation };
};
